import { useSignal } from "@preact/signals-react";

import BoardTable from "componentsv2/table/BoardTable";
import BoardForm from "componentsv2/form/BoardForm";
import BoardCards from "componentsv2/card/BoardCards";
import BoardKanban from "componentsv2/kanban/BoardKanban";
import ModalTable from "componentsv2/table/ModalTable";
import CalendarFilter from "componentsv2/widgets/CalendarFilter";
import { cn } from "tools/ui";
import Loading from "componentsv2/widgets/Loading";
import { useAutoOpen } from "./hooks/useAutoOpen";

const baseStyle = "h-full bg-neutral-100 px-3 lg:px-4";

/**
 * This component renders a table or a form from a context view object
 * @param {object} props - component props
 * @param {Function} props.layout - object to render view
 * @returns {Component}
 */
function Board(props) {
  const recordStoreId = useSignal(null);
  const autoOpen = useAutoOpen(props.layout);
  const {
    layout,
    calendar,
    handleCalendar,
    reload,
    currentView,
    reloadId,
    setView,
    showBackButton,
    returnFilter,
  } = props;

  if (!layout) {
    return <Loading />;
  }

  if (layout?.defaultView) {
    currentView.value = layout.defaultView;
  }

  function handleView(action, recStoreId) {
    if (["edit", "add"].includes(action)) {
      currentView.value = "form";
      recordStoreId.value = recStoreId;
    } else {
      currentView.value = "list";
      recordStoreId.value = null;
    }
  }

  let style = "w-full";
  if (props.style) {
    style = props.style;
  }

  let board;
  if (currentView?.value === "form") {
    if (recordStoreId.value) {
      board = (
        <BoardForm
          title={true}
          layout={layout}
          storeId={recordStoreId.value}
          handleView={handleView}
        />
      );
    }
  } else if (currentView.value === "list") {
    board = (
      <BoardTable
        layout={layout}
        handleView={handleView}
        reloadId={reloadId}
        setView={setView}
        showBackButton={showBackButton}
        returnFilter={returnFilter}
        recordStoreId={autoOpen?.modalRecordStoreId}
        openModal={autoOpen?.openModal}
      />
    );
  } else if (currentView.value === "cards") {
    board = <BoardCards layout={layout} Card={layout.Card} />;
  } else if (currentView.value === "column") {
    board = <BoardKanban layout={layout} reload={reload} setView={setView} />;
  }

  return (
    <div id="board" className={cn(baseStyle, style)}>
      {currentView.value === "list" && calendar && (
        <CalendarFilter action={handleCalendar} styleContent="pl-4" />
      )}
      {board}
      <ModalTable />
    </div>
  );
}

export default Board;
